// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"247":"ff804112","746":"7064611b","788":"11390db7","792":"b2d98e07"}[chunkId] || chunkId) + "." + {"247":"e4587fb03d2a0dc3","619":"f50e9c43f0df8065","746":"1167aac087ac0269","788":"d07bc014de403300","792":"e3409fe1dedee98a"}[chunkId] + ".js";
};